import React, { Component } from "react";
import { Button, Modal, Row, Col, Typography } from "antd";
import axios from 'axios';

const { Text, Title } = Typography;


class ModalPaymentsType extends Component {

    filters = this.props.filters

    getInfo = ({ filters } = {}) => {
        console.log('getINFOPAYMENTS');
        this.setState({ loading: true })
        axios.get('/analytics-payments', {
            params: {
                filters
            }
        }).then((response) => {
            console.log('payments', response)
            response.data.map(payment => {
                console.log('payment', payment)
                switch (payment._id) {
                    case 1:
                        this.setState({ cash: payment.total })
                        break;
                    case 2:
                        this.setState({ square: payment.total })
                        break;
                    case 3:
                        this.setState({ zelle: payment.total })
                        break;
                    case 4:
                        this.setState({ venmo: payment.total })
                        break;
                    case null:
                        this.setState({ other: payment.total })
                        break;
                    default:
                        this.setState({ other: payment.total })
                        break;
                }
            })
            this.setState({ loading: false })
        }).catch((error) => {
            console.log('error', error)
            this.setState({ loading: false })
        })

    }
    constructor(props) {
        super(props);

        this.state = {
            loading: false,

            cash: 0,
            square: 0,
            zelle: 0,
            venmo: 0,
            other: 0

        }

    }

    componentDidMount() {
        this.getInfo()
    }

    render() {
        return <>
            <Row gutter={[16, 16]} justify={"center"}>
                <Col span={12}>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '1.5em' }}>Cash</Text>
                    </Row>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '2.5em' }}>$ {this.state.cash.toMoney(true)} USD</Text>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '1.5em' }}>Square</Text>
                    </Row>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '2.5em' }}>$ {this.state.square.toMoney(true)} USD</Text>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '1.5em' }}>Zelle</Text>
                    </Row>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '2.5em' }}>$ {this.state.zelle.toMoney(true)} USD</Text>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '1.5em' }}>Venmo</Text>
                    </Row>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '2.5em' }}>$ {this.state.venmo.toMoney(true)} USD</Text>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '1.5em' }}>Other</Text>
                    </Row>
                    <Row justify={"center"}>
                        <Text strong style={{ fontSize: '2.5em' }}>$ {this.state.other.toMoney(true)} USD</Text>
                    </Row>
                </Col>

            </Row>
        </>
    }

}

export default function paymentsType(props) {
    const { visible = false, onClose = () => { }, zone, title, filters } = props

    return <Modal
        open={visible}
        onCancel={onClose}
        title={title ?? "Payments Type"}
        destroyOnClose={true}
        footer={[
            <Button key="back" onClick={onClose}>
                Return
            </Button>,
        ]}

        width={'80%'}
    >
        <ModalPaymentsType {...props} />
    </Modal>


}